<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="PropertyId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.list"
      urlHash="finance/dealings/othereceive"
      @showRow="showRow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onImprot">导入</el-button>
        <el-button type="primary" @click="onExport">导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-table class="subItem-table" :data="subList" v-if="show" border>
      <el-table-column
        align="center"
        prop="Abstract"
        label="摘要"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ItemName"
        label="项目"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Amount"
        label="金额"
        v-if="canPrice"
      >
        <template slot-scope="{ row }">
          {{ row.Amount.toLocaleString() }}
        </template>
      </el-table-column>
    </el-table>

    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/finance/dealings/othereceive/list.json";
import tableParam from "@/data/finance/dealings/othereceive/query.json";
import importDialog from "./importDialog";

export default {
  mixins: [listMixin],
  components: { list, importDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/rp/otherReceiv").default,

      show: false,
      subList: [],
      params: {
        RankName: "",
        Status: null,
      },
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/othereceive");
    },
  },
  methods: {
    onImprot() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map((x) => x.tableName);
          var params = { ...listParams, Fields: fields.join(",") };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.export(params).then((res) => {
            loading.close();
          });
        })
        .catch(() => {});
    },
    showRow(data) {
      console.log("showRow", data);
      // console.log('当前行');
      console.log(data);
      this.show = false;
      this.api.info(data.OtherReceivId).then((res) => {
        if (res.Code === 0 && res.Data.RpOtherReceivDts.length > 0) {
          this.subList = res.Data.RpOtherReceivDts;
          this.show = true;
        }
      });
      // this.subList.push(data)
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
